import React from "react";

function PageNotFound() {
  return (
    <div className="pageNotFound">
      <h1>You are either on the wrong url or not logged in, Page not found</h1>
    </div>
  );
}

export default PageNotFound;
